import { Button, Card, Stack, Typography } from '@mui/material';
import ROUTES from 'constants/routes';
import { useUnit } from 'effector-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { $user } from 'store/user/model';

export enum MessageVariant {
  ACCESS,
  ERROR,
}

interface AssesmentAccessCardProps {
  messageVariant?: MessageVariant;
}

const AssesmentAccessCard = ({
  messageVariant = MessageVariant.ACCESS,
}: AssesmentAccessCardProps) => {
  const navigate = useNavigate();
  const [me] = useUnit([$user]);
  const { t } = useTranslation();

  const handleClick = () => {
    navigate(ROUTES.ASSESSMENT, { replace: true });
  };

  const title = useMemo(() => {
    if (messageVariant === MessageVariant.ACCESS) return t('assessment.accessCard.completed');
    if (messageVariant === MessageVariant.ERROR) return t('assessment.accessCard.error');
    return t('assessment.accessCard.error');
  }, [messageVariant]);

  return (
    <Card sx={{ maxWidth: 976, textAlign: 'center', marginX: 'auto' }}>
      <Stack spacing={4} alignItems='center'>
        <Stack spacing={1}>
          <Typography variant='h28'>{title}</Typography>
          <Typography variant='h20'>{t('assessment.accessCard.contactAdmin')}</Typography>
        </Stack>
        {!!me && (
          <Button onClick={handleClick} variant='outlined'>
            {t('header.assessments')}
          </Button>
        )}
      </Stack>
    </Card>
  );
};

export default AssesmentAccessCard;
